import { render, staticRenderFns } from "./channel-detailed-history.vue?vue&type=template&id=cfdb3490&scoped=true"
import script from "./channel-detailed-history.vue?vue&type=script&lang=js"
export * from "./channel-detailed-history.vue?vue&type=script&lang=js"
import style0 from "./channel-detailed-history.vue?vue&type=style&index=0&id=cfdb3490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb3490",
  null
  
)

export default component.exports